<template>
    <div>
        <div v-if="!isEmailConfirmed && isLoggedIn()" class="text-center">
            <div class="text-verify-email px-5 py-1 system-border">
                <i class="fas fa-exclamation-triangle icon-color-yellow pr-1 shadow-text-none"></i>
                {{ $t('email_please_confirm') }}
                <button
                    v-if="!isSending"
                    @click="resendEmail"
                    :class="{ 'opacity-50 cursor-not-allowed': isDisabled }"
                    class="ml-1 px-3 py-1 system-button-color system-button-text-color border-none text-sm font-medium rounded-full cursor-pointer"
                >
                    {{ $t('email_button_resend') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { isLoggedIn, currentUser } from '@/lib/user.js'
import popup from '@/lib/popup.js'
import { load } from 'recaptcha-v3'

export default {
    name: 'VerifyEmail',

    data() {
        return {
            isConfirmed: false,
            isConfirmedLocal: false,
            isSending: false,
            isDisabled: false
        }
    },

    computed: {
        isEmailConfirmed() {
            return this.isConfirmedLocal || this.isConfirmed
        }
    },

    mounted() {
        if (isLoggedIn()) {
            this.isConfirmed = currentUser().is_confirm_email || !currentUser().is_google2fa
            this.isConfirmedLocal = localStorage.getItem('is_confirm_email_' + currentUser().id)
        }

        var today = new Date()
        var diffMs = today.getTime() - localStorage.getItem('time_sending')
        var minutes = Math.floor(diffMs / 60000)

        if (minutes < 10) {
            this.isSending = true
        }
    },

    methods: {
        getRecaptchaSiteKey() {
            return process.env.VUE_APP_RECAPTCHA_SITE_KEY
        },

        async resendEmail() {
            this.isDisabled = true
            const recaptcha = await load(this.getRecaptchaSiteKey(), {
                useRecaptchaNet: true,
                autoHideBadge: true
            })

            const token = await recaptcha.execute('validate_captcha', {
                action: 'validate_captcha'
            })

            this.$store
                .dispatch('resendToEmail', {
                    id: currentUser().id,
                    captcha_response: token
                })
                .then(res => {
                    this.isDisabled = false
                    this.isSending = true

                    const user = res.data.data

                    localStorage.setItem('time_sending', new Date().getTime())
                    popup.alert(this.$t('email_resend_success', { email: user.email }))
                })
                .catch(() => {
                    this.isDisabled = false
                    popup.alert(this.$t('email_resend_fail'))
                })
        }
    }
}
</script>

<style scoped>
.text-verify-email {
    border-radius: 15px;
    background-color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    color: rgb(200, 0, 0);
    overflow: hidden;
    display: inline-block;
}
.icon-color-yellow {
    color: #fccb19;
}
</style>
